import { Component, EventEmitter, Input, Output } from '@angular/core';
import { ImportContainer } from 'app/Model/dataProcess/importContainer';
import { ProductDataSource } from 'app/Model/dataProcess/productDataSource';
import { DataSourcesService } from 'app/Services/DataProcess/datasources.service';
import { LoginService } from 'app/Services/login.service';
import { Address } from "../../../Model/Catalog/Address";

@Component({
  selector: 'np-inspect-container-details-context',
  templateUrl: './inspect-container-details-context.component.html',
  styleUrl: './inspect-container-details-context.component.css'
})
export class InspectContainerDetailsContextComponent {
  @Output() containerSaved = new EventEmitter<ImportContainer>();
  dataSource: ProductDataSource;
  editVisible: boolean = false;

  constructor(
    private dataSourceService: DataSourcesService,
    private loginService: LoginService
  ) {
    this.loadSupplier = this.loadSupplier.bind(this);
  }

  private _container: ImportContainer;

  get container(): ImportContainer {
    return this._container;
  }

  @Input()
  set container(value: ImportContainer) {
    this._container = value;
    this.loadSupplier().then();
  }

  async loadSupplier(): Promise<void> {
    if (this.container) {
      this.dataSource = await this.dataSourceService.get(this.container.dataSourceId, this.loginService.currentCustomer.id);
      if (this.dataSource && !this.dataSource.importerAddress) {
        this.dataSource.importerAddress = new Address();
      }
    }
  }

  openContainerEdit(): void {
    this.editVisible = true;
  }

  async onContainerSaved(updated: ImportContainer) {
    this.containerSaved.emit(updated);
  }
}
